module.exports = __webpack_public_path__ + "static/img/address_icon.b3d6876d.png";